import styled from 'styled-components'
import Button from '@material-ui/core/Button'
import React from 'react'
import { tokens, primitives } from '../../../assets/tokens'

const { color } = tokens

// Botón que abre un menú con aspecto de selector: mismo alto, borde, fuente y chevron que los
// Autocomplete del tema, para que «Marcar como» y «Editar estado actual» se vean iguales.
export const ButtonStyled = styled(props => <Button {...props} />)`
  && {
    opacity: ${props => (props.disabled ? 0.4 : 1)};
    cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
    pointer-events: ${props => (props.disabled ? 'none' : 'auto')};
    margin-left: 12px;
    width: 220px;
    height: 40px;
    padding: 0 12px 0 14px;
    box-sizing: border-box;
    justify-content: space-between;
    border: 1.5px solid ${color.border.default};
    border-radius: 8px;
    background-color: ${color.background.default};
    font-family: ${tokens.typography.fontFamily.primary};
    font-weight: 400;
    font-size: 14px;
    line-height: 1.4;
    color: ${color.text.secondary};
    text-transform: none;
    transition: border-color 0.2s ease;

    :hover {
      background-color: ${color.background.default};
      border-color: ${props => props.theme.primary || color.brand.primary};
    }

    .MuiButton-label {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
    }

    .button-dropdown-chevron {
      flex-shrink: 0;
      color: ${primitives.neutral[800]};
    }
  }
`
